import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  skipped: { color: 'default', label: 'Skipped' },
  proposed: { color: 'info', label: 'Proposed' },
  failed: { color: 'error', label: 'Failed' },
  passed: { color: 'success', label: 'Passed' },
  not_applicable: { color: 'default', label: 'N/A' },
};

const StatusBadge = ({ value, size = 'small', variant = 'filled' }) => {
  const config = STATUS_CONFIG[value] || {
    color: 'default',
    label: value || 'Unknown',
  };

  return <Chip size={size} color={config.color} label={config.label} variant={variant} />;
};

StatusBadge.propTypes = {
  value: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined']),
};

export default StatusBadge;
